import React from "react";
import HeroSection from "../../components/services/HeroSection";
import CardInfoSection from "../../components/services/CardInfoSection";
import WorkSection from "../../components/services/WorkSection";
import ContactSection from "../../components/services/ContactSection";
const index = () => {
  return (
    <div>
      <HeroSection />
      <CardInfoSection />
      <WorkSection />
      <ContactSection />
    </div>
  );
};

export default index;
